@use '@design/design-tokens/typography/typography' as *;

.resetButton {
  [data-button-label] {
    @include typography-v2-title-sm;
    font-weight: normal;
    color: var(--text-primary);
  }

  svg {
    fill: var(--text-primary);
  }
}
